export default __webpack_public_path__ + "static/media/s-squiggle-105.8d7fcfda.svg";